export class SetTitle {
  static type = '[RT Titles] SetTitle';

  constructor(public title: string) {
  }
}
